import { createSlice } from '@reduxjs/toolkit'
import { sendConnectCommand } from '../actions/audio.action'
import { Audio } from '@dataTypes/index'

export type AudioState = {
  data: Audio | null
  loading: boolean
  error: null
}

const initialState: AudioState = {
  data: null,
  loading: false,
  error: null,
}

export const audioConnectSlice = createSlice({
  name: 'audios',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(sendConnectCommand.fulfilled, (state) => {
      state.loading = false
    })
    builder.addCase(sendConnectCommand.pending, (state) => {
      state.loading = true
    })
    builder.addCase(sendConnectCommand.rejected, (state) => {
      state.error = null
      state.loading = false
    })
  },
})

export default audioConnectSlice.reducer
